module.exports = __webpack_public_path__ + "img/14.d828467d.jpg";